/**
 * @module Shop FAQs
 * @description
 */
import Link from "next/link";
import FAQs from "@/blocks/FAQS";
import { trackEvent } from "@/js/helpers/tracking";

/**
 * @function Component
 * @description Hero that displays headline and predictive service check
 */
const Component = () => {
  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const { target } = event;
    const text = target.innerHTML;
    const data = {
      elementType: "LINK",
      position: "FAQ",
      text,
      actionOutcome: "INTERNALLINK",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <FAQs
      accordionData={[
        {
          title:
            "Is Frontier Fiber Internet service available in my neighborhood?",
          content:
            "Frontier Fiber is available in many neighborhoods across 17 states and adding more every day.",
        },
        {
          title: "How fast are Frontier Fiber Internet Speeds?",
          content:
            "On our 100% fiber-optic network to the home, max wired download/upload speeds can range as fast as 5000/5000 Mbps where available.",
        },
        {
          title: "What is Frontier Fiber Internet?",
          content:
            "Frontier Fiber Internet uses a collection of ultra-thin fiber-optic wires encased in a cable to deliver your connection.",
        },
        {
          title: "Which Frontier Internet plan is best for me?",
          content:
            "The internet plan you choose should depend on a few factors. The number of devices and users in your home, what those users do on the web and even your home’s floor plan correlate with the speed you need. If you live in a home with many connected devices and users or a home with lots of walls, consider a faster speed so everyone can do what they love with ease. If you need help deciding, give our fiber internet experts a call and they’ll help you determine the plan right for you",
        },
        {
          title: "Does Frontier have internet and TV bundles?",
          content: (
            <>
              We’ve partnered with YouTube TV to bring you cable-free TV. With
              Frontier®️ Internet and YouTube TV, you can stream live & local
              sports, news and shows from 100+ channels including ABC, CBS, FOX,
              NBC, ESPN, FX, Disney Channel, HGTV, TNT, and more.
              <br />
              <br />
              Local and regional programming is also provided with YouTube TV,
              offering complete local network coverage in over 98% of U.S. TV
              households. Please visit the{" "}
              <Link
                target="_blank"
                key="link-2"
                href="https://streaming.frontier.com/channel-lineup/youtube?iframe"
                onClick={handleClick}
              >
                Youtube TV Channel Lineup
              </Link>{" "}
              and enter your 5-digit ZIP code for a full list of your area's
              channel lineup. Or,{" "}
              <Link
                target="_blank"
                key="link-3"
                href="https://frontier.com/shop/tv"
                onClick={handleClick}
              >
                learn more about Youtube TV
              </Link>
              .
            </>
          ),
        },
      ]}
    />
  );
};

export default Component;
